import fetch from '../../../services/fetch-api.service';

const fetchDistricts = ({ filters, page, sortField, sortOrder, limit }) => fetch.get('admin/districts/list', { filters, page, sortField, sortOrder, limit });

export default {
  fetchDistricts,
};
